import { useAuthContext } from "./AuthContext";
import MessagesProvider from "./MessagesContext";

const MessagesProviderWrapper = ({ children }) => {
  const { authState } = useAuthContext();

  // impersonated user lives here when setImpersonate is used
  const impersonatedUser = authState?.impersonate || null;
  const impersonateUserId = impersonatedUser?._id || null;

  return (
    <MessagesProvider
      mode={impersonateUserId ? "inspector" : "normal"}
      inspectedUserId={impersonateUserId}
    >
      {children}
    </MessagesProvider>
  );
};

export default MessagesProviderWrapper;
